import { Box, SxProps, Theme } from '@mui/material';

type SurveyCardProps = Readonly<{
  width: string;
  children: React.ReactNode;
}>;

export function SurveyCard({ width, children }: SurveyCardProps) {
  return <Box sx={cardSx(width)}>{children}</Box>;
}

const cardSx =
  (width: string): SxProps<Theme> =>
  ({ backrs }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: backrs.colors['Colors/Base/White'],
    maxWidth: width,
    width,
    flexShrink: 1,
    minWidth: 0,
    borderRadius: '1rem',
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
    zIndex: 1,
    animation: 'fadeInUp 0.4s ease-out',
    '@keyframes fadeInUp': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' },
    },
    '@media (max-width: 600px)': {
      width: '100%',
      maxWidth: '100%',
    },
  });
